import { Component, OnInit } from "@angular/core";
import { StorageService } from "@app/services/storage/storage.service";
import { Router } from "@angular/router";
import { FormGroup, FormControl } from '@angular/forms';
import Vs from '@app/services/validators/validators.service';
import { saveAs } from 'file-saver'
import { ApplicationService } from "@app/services/application/application.service";
import { DatePipe } from '@angular/common';
import { ServiceConfigService } from '@app/services/service-config.service';

@Component({
    selector: "nh-memberLogin-details",
    templateUrl: "./memberLoginDetails.component.html",
    styleUrls: ["./memberLoginDetails.component.scss"],
    standalone: false
})

export class MemberLoginDetailsComponent implements OnInit {
    personId = sessionStorage.getItem("individualId");
    today: any = new Date();
    memberName = ""
    memberDetails = [];
    memberDetailsColumns = [
    { name: "Account Owner Name", prop: "registeredName" },
    { name: "Account Username", prop: "userName" },
    { name: "Account Email", prop: "email" },
    { name: "Account Creation Date", prop: "accountCreatedDate" },
    { name: "Last Login Date", prop: "lastAccessedDate" }
  ];
    minimumDate = new Date("1900-01-01T00:00:00.000-06:00");
    search = new FormGroup({
        beginDate: new FormControl('', [Vs.notBefore120Years]),
        endDate: new FormControl('', [Vs.notBefore120Years])
    })
    beginDateError: any = { isError: false, errorMessage: '' };
    endDateError: any = { isError: false, errorMessage: '' };
    displayDates = [];
    chunkedDates: Date[][] = [];
    chunkSize= 0;
    currentChunkIndex =0;

    selectedDate: Date | null = null;
    selectedData : any = {date : "", sessions : []};
    noLoginData= null
    expandedIndex: number | null = null;
    currentIdentifier : number | null = null;
    groupedList: { id: number, items: any[] }[] = [];
    constructor(
        protected storageService: StorageService,
        private router: Router,
        protected application: ApplicationService,
        private datePipe: DatePipe,
        private serverConfig: ServiceConfigService
    ) {
    }


    get f() {
        return this.search.controls;
    }


    jsonToCsv(json) {

        const sessions = json.sessions;
        if (!sessions.length) {
            return 'No sessions to export'
        }
        const rows = sessions.map(session => ({
            accountOwnerName: json.accountOwnerName,
            accountEmail: json.email,
            date: json.date,
            ...session
        }));
        rows.forEach(element => {
            delete element.visitedScreens
        });
        const headers = Object.keys(rows[0]);
        let csvString;
        const csvRows = rows.map(row =>
            headers.map(field => {
                if (field !== "screensViewed") {
                    const val = row[field] !== null && row[field] !== undefined ? row[field] : '';
                    return `"${String(val).replace(/"/g, '""')}"`;
                } else {
                    const csvArray = row[field].flatMap(item =>
                        Array.isArray(item.value) ? [item.key, ...item.value] : item.key
                    );
                    csvString = csvArray.join(',');
                    return `"${String(csvString).replace(/"/g, '""')}"`;
                }
            }).join(',')
        );
        return [headers.join(','), ...csvRows].join('\r\n')
    }


    exportExcel(selectedData): void {
        selectedData.accountOwnerName = this.memberDetails[0]['registeredName']
        selectedData.email = this.memberDetails[0]['email']
        const csv = this.jsonToCsv(selectedData)

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        saveAs(blob, 'MemberPortalLogin_' + this.datePipe.transform(this.selectedDate, 'MM-dd-yyy') + '.csv')
    }


    ngOnInit() {
        this.chunkSize = Number(this.serverConfig.getServerConfig().memberLoginChunkSize)
        this.application.getMemberdata(this.personId).subscribe((res: any) => {
            if (res) {
                this.memberDetails = [{
                    "registeredName": res['registeredUserName'],
                    "userName": res['userName'],
                    "email": res['email'],
                    "accountCreatedDate": this.datePipe.transform(res['accountCreatedDate'], 'MM/dd/yyy'),
                    "lastAccessedDate": this.datePipe.transform(res['lastAccessedDate'], 'MM/dd/yyy'),
                }]
                this.memberName = res['memberName'] ? res['memberName']  :  sessionStorage.getItem("memberName");
            }
        })
    }

    onPrevious() {
        sessionStorage.removeItem('indivIds');
        this.router.navigateByUrl("api/prov/member-search?type=MPL");
    }

    setValidator() {
        if (this.f.beginDate.value) {
            this.search.get('endDate').setValidators([Vs.required, Vs.notBefore120Years])
        } else {
            this.search.get('endDate').clearValidators()
        }
    }

    verifyTwoDates(event, from) {
        const date = event?.target?.value ? event?.target?.value : event ? event : null;
        if (date) {
            if(from === 'beginDate'){
              this.search.controls.beginDate.patchValue(date);
              const beginDate = this.datePipe.transform(this.search.controls['beginDate'].value, 'MM-dd-yyy');
              const endDate = this.datePipe.transform(this.search.controls['endDate'].value, 'MM-dd-yyy');
              if(beginDate && endDate && endDate < beginDate ){
                this.beginDateError = { isError: true, errorMessage: 'BEGIN_DATE_BEFORE_END_DATE' },
                this.endDateError = { isError: false, errorMessage: '' }
              } else {
               this.beginDateError = { isError: false, errorMessage: '' };
               this.endDateError = { isError: false, errorMessage: '' }
              }

            } else {
            this.search.controls.endDate.patchValue(date);
            const beginDate = this.datePipe.transform(this.search.controls['beginDate'].value, 'MM-dd-yyy');
            const endDate = this.datePipe.transform(this.search.controls['endDate'].value, 'MM-dd-yyy');
             if(beginDate && endDate && endDate < beginDate ){
                this.endDateError = { isError: true, errorMessage: 'BEGIN_DATE_BEFORE_END_DATE' };
                this.beginDateError = { isError: false, errorMessage: '' };
              } else {
                this.beginDateError = { isError: false, errorMessage: '' };
                this.endDateError = { isError: false, errorMessage: '' }
              }
            }
        };
    };

    findDiff(x, y) {
        const Difference_In_Time = y.getTime() - x.getTime();
        const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        return Difference_In_Days <= 0 ? 0 : Difference_In_Days;
    };

    searchData(identifier, from) {
        const payLoad = {
            "indvId": this.personId,
            "beginDate": this.datePipe.transform(this.search.controls.beginDate.value, "yyyy-MM-dd"),
            "endDate": this.datePipe.transform(this.search.controls.endDate.value, "yyyy-MM-dd"),
            "identifier": identifier,
        }
        this.currentIdentifier = identifier;
        if(from === 'search'){
        this.application.getMemberLoginDetails(payLoad).subscribe((res: any) => {
            if (res?.userActivityDates?.length) {             
                this.displayDates = res.userActivityDates
                this.noLoginData = false;
                this.groupingRecords(this.displayDates)
                this.chunkedDates = this.splitIntoChunk(this.displayDates, this.chunkSize);
                this.onDateSelect(this.chunkedDates[0][0])
            } else {
                this.noLoginData = true
            }
        })
        } else {
             this.currentChunkIndex = identifier-1;
             this.onDateSelect(this.chunkedDates[identifier-1][0])
        }
    }

    groupingRecords(userActLogSeqNums) {
        const groupSize =  this.chunkSize;
        let groupIdCounter = 1;
        this.groupedList = [];
        for (let i = 0; i < userActLogSeqNums.length; i += groupSize) {
            const groupItems = userActLogSeqNums.slice(i, i + groupSize);
            this.groupedList.push({
                id: groupIdCounter,
                items: groupItems
            });
            groupIdCounter++;
        }
    }

    generateDatesBetween(beginDate: Date, endDate: Date): Date[] {
        const date = new Date(beginDate);
        const dates: Date[] = [];
        for (date; date <= endDate; date.setDate(date.getDate() + 1))
            dates.push(new Date(date))
        return dates;
    }

    splitIntoChunk(arr ,size: number) {
        const result = [];
        for(let i=0; i< arr.length; i+= size){
            result.push(arr.slice(i,i + size));
        }
        return result;
    }

    onDateSelect(date) {
        this.selectedDate = date;
        const payLoad = {
            "searchUserId": this.memberDetails[0]['userName'],
            "identifier": this.currentIdentifier,
            "selectedDate": date
        }
        this.application.getMemberActivityHistory(payLoad).subscribe((res: any) => {
            if (res?.userSessionsData?.length) {
                this.selectedData = res.userSessionsData[0];
                this.selectedData = this.getListOfScreens(this.selectedData)
            }
        })
        this.expandedIndex = null;
    }

    getListOfScreens(data) {
        for (let i = 0; data.sessions.length > i; i++) {
            data.sessions[i]['visitedScreens'] = data.sessions[i]['screensViewed']
            data.sessions[i]['sessionTime'] = this.formatDate(data.sessions[i]['sessionTime'])
        }
        return data
    }

    formatDate(dateString){
  const date = new Date(dateString); // Parse the input string
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString().padStart(2, '0'); // Add 1 to month and pad
  const day = date.getDate().toString().padStart(2, '0'); // Pad day

  let hours = date.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // Handle midnight (0 hours)
  const minutes = date.getMinutes().toString().padStart(2, '0'); // Pad minutes

  return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
}


      toggleExpand(index: number): void {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }
    

}
